const SvgAutomation3 = (props) => (
  <>
    <path
      fill={props.p20}
      opacity={0.5}
      d="m79.817 144.001 47.999-47.998L175.814 144l-47.998 47.998zM79.82 240.003l47.998-47.998 47.998 47.998-47.998 47.999z"
    />
    <path
      fill={props.p20}
      opacity={0.5}
      d="m79.822 335.995 47.998-47.998 47.999 47.998-47.999 47.999zM79.825 47.999 127.824 0 175.822 48l-47.998 47.998z"
    />
    <path
      fill="none"
      stroke={props.p50}
      strokeMiterlimit={10}
      d="m63.82 192.137 63.847-64.138 64.152 63.862-63.847 64.138z"
    />
    <path
      fill="none"
      stroke={props.p50}
      strokeMiterlimit={10}
      d="m63.823 96.139 63.848-64.138 64.152 63.862L127.975 160zM63.824 289.14l63.848-64.138 64.152 63.862-63.848 64.138z"
    />
  </>
);

export default SvgAutomation3;
